import { axios } from '@/common/api.service.js'

function executeCampaignArtefactRequest(headers, parm) {
  const requestHeaders = { ...(headers || {}) }

  if (parm?.payload instanceof FormData) {
    // Let axios/browser set the multipart boundary automatically.
    // Keeping the JSON Content-Type here can cause DRF to parse an
    // effectively empty payload on PATCH requests.
    delete requestHeaders['Content-Type']
    delete requestHeaders['content-type']
  }

  return new Promise((resolve, reject) => {
    axios({
      method: parm.api_request.method,
      url: parm.api_request.endpoint,
      headers: requestHeaders,
      data: parm.payload,
      mode: 'same-origin',
    })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

console.log('HERE CampaignArtefactsJS')
//---------------
// set state
//---------------
const state = () => ({
  campaignArtefacts: [],
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})
//---------
// getters
//---------
const getters = {
  //------------------------
  // get campaign artefacts
  //------------------------
  getCampaignArtefacts(state) {
    return state.campaignArtefacts
  },
  //-------------------------------
  // get campaign artefact by name
  //-------------------------------
  getCampaignArtefactByName: (state) => (name) => {
    let artefact = state.campaignArtefacts.find((a) => a.name == name)
    try {
      return artefact
    } catch {
      return null
    }
  },
  //-----------------------------
  // get campaign artefact by id
  //-----------------------------
  getCampaignArtefactById: (state) => (id) => {
    let artefact = state.campaignArtefacts.find((a) => a.id == id)
    try {
      return artefact
    } catch {
      return null
    }
  },
  //-------------
  // get headers
  //-------------
  getHeaders(state) {
    return state.headers
  },
}
//---------
// actions
//---------
const actions = {
  //===============================================================
  // load static campaign artefacts
  //--------------------------------
  async loadStaticCampaignArtefacts({ commit, state }, arenaId) {
    console.log('-----------------------')
    console.log('JS loadStaticCampaignArtefacts..')
    const endpoint = arenaId
      ? `api/v1/campaign-artefacts/arena/${arenaId}/`
      : 'api/v1/campaign-artefacts/'
    const headers = state.headers
    await axios
      .get(endpoint, {
        headers: headers,
        mode: 'same-origin',
      })
      //--------------
      // where api ok
      //--------------
      .then((response) => {
        commit('setCampaignArtefacts', response.data.results)
      })
      //-----------------
      // where api error
      //-----------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
  },
  //===============================================================
  // edit campaign artefact (add/change)
  //------------------------------------
  editCampaignArtefact({ state }, parm) {
    console.log('-----------------------------')
    console.log('IN editCampaignArtefact....')
    return executeCampaignArtefactRequest(state.headers, parm)
  },
  editArtefact({ state }, parm) {
    return executeCampaignArtefactRequest(state.headers, parm)
  },
  //===============================================================
  // delete campaign artefact
  //--------------------------
  deleteCampaignArtefact({ state }, request) {
    console.log('----------------')
    console.log('IN deleteCampaignArtefact...')
    return executeCampaignArtefactRequest(state.headers, {
      api_request: request,
    })
  },
  //===============================================================
  // change campaign artefact image (patch)
  //----------------------------------------
  changeCampaignArtefactImage(_, parm) {
    const endpoint = 'api/v1/campaign-artefacts/' + parm.slug + '/image/'

    return new Promise((resolve, reject) => {
      axios({
        method: 'patch',
        url: endpoint,
        headers: { 'content-type': 'multipart/form-data' },
        data: parm.image_file,
        mode: 'same-origin',
      })
        //----------
        // where ok
        //----------
        .then((response) => {
          resolve(response)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((error) => {
          reject(error)
        })
    })
  },
}
//===============================================================
// mutations
//-----------
const mutations = {
  setCampaignArtefacts(state, payload) {
    state.campaignArtefacts = payload
  },
}
//===============================================================
// export
//--------
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
